let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cZwzf")).then(() => parcelRequire('622BY'));